const reasons = [
  {
    no: "01",
    title: "Clear Learning Structure",
    text: "Every program follows a defined path so learners always know what comes next and why it matters.",
  },
  {
    no: "02",
    title: "Guided Decision-Making",
    text: "We focus on mentoring and guidance to help learners make thoughtful choices, not rushed ones.",
  },
  {
    no: "03",
    title: "Clarity Over Overload",
    text: "Instead of adding more, we refine what matters—keeping learning focused and understandable.",
  },
  {
    no: "04",
    title: "Built for Long-Term Growth",
    text: "Our approach supports continuous development beyond short-term results or certifications.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="relative bg-white overflow-hidden pt-0 pb-8 sm:pb-14 lg:pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-[#0b1b4d]">
            Why learners choose Ekamdhyas
          </h2>

          <div className="mt-4 sm:mt-6 lg:mt-8 flex items-center justify-center gap-2">
            <span className="h-1 w-20 rounded-full bg-indigo-600" />
            <span className="h-1 w-3 rounded-full bg-indigo-300" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-x-12 md:gap-y-10 lg:gap-x-16 lg:gap-y-14 max-w-6xl mx-auto">
          {reasons.map((item) => (
            <div key={item.no} className="flex items-start gap-4 sm:gap-5">
              <span className="text-2xl sm:text-3xl font-extrabold text-indigo-200 flex-shrink-0">
                {item.no}
              </span>

              <div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">
                  {item.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
